import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "flex flex-col gap-2 text-center" };
const _hoisted_2 = ["id"];
const _hoisted_3 = ["id"];
const _hoisted_4 = { class: "flex items-center gap-4" };
import { useId } from "vue";
import { Button, Modal } from "@eudonet/opal";
export default /*@__PURE__*/ _defineComponent({
    __name: 'UserActionConfirmModal',
    props: {
        modelValue: { type: Boolean },
        titleKey: {},
        bodyKey: {},
        confirmKey: {},
        danger: { type: Boolean },
        loading: { type: Boolean }
    },
    emits: ["accept", "cancel"],
    setup(__props) {
        const titleId = useId();
        const descriptionId = useId();
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(Modal), {
                "model-value": __props.modelValue,
                size: "xs",
                "show-header": false,
                "footer-position": "center",
                "aria-labelledby": _unref(titleId),
                "aria-describedby": _unref(descriptionId),
                "data-testid": "user-action-confirm-modal",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = (v) => !v && _ctx.$emit('cancel'))
            }, {
                footer: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                        _createVNode(_unref(Button), {
                            variant: "secondary",
                            label: _ctx.$t('common.cancel'),
                            disabled: __props.loading,
                            onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('cancel')))
                        }, null, 8 /* PROPS */, ["label", "disabled"]),
                        _createVNode(_unref(Button), {
                            variant: __props.danger ? 'error' : 'primary',
                            label: __props.confirmKey ? _ctx.$t(__props.confirmKey) : '',
                            loading: __props.loading,
                            "data-testid": "user-action-confirm-accept",
                            onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('accept')))
                        }, null, 8 /* PROPS */, ["variant", "label", "loading"])
                    ])
                ]),
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("span", {
                            id: _unref(titleId),
                            class: "font-bold text-xl leading-6 text-(--text-text-black-default) dark:text-(--text-text-white-default)"
                        }, _toDisplayString(__props.titleKey ? _ctx.$t(__props.titleKey) : ""), 9 /* TEXT, PROPS */, _hoisted_2),
                        _createElementVNode("span", {
                            id: _unref(descriptionId),
                            class: "text-base leading-6 text-(--text-text-body)"
                        }, _toDisplayString(__props.bodyKey ? _ctx.$t(__props.bodyKey) : ""), 9 /* TEXT, PROPS */, _hoisted_3)
                    ])
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["model-value", "aria-labelledby", "aria-describedby"]));
        };
    }
});
